import store from 'store';
class AppController {

    constructor($rootScope, $state, permissionsService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.user = permissionsService.user;
    }

    getOffcanvasCollapsed() {
        return store.get('offcanvasCollapsed');
    }

    setOffcanvasCollapsed() {
        let current = store.get('offcanvasCollapsed');
        store.set('offcanvasCollapsed', !current);
    }
}

AppController.$inject = [ '$rootScope', '$state', 'permissionsService' ];

export default AppController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/controllers/app.controller.js